/**
 * 马甲站类别 icon 映射（原型 8 类 + 兜底）。
 * 运营新增类别名不在表内时回落 defaultIcon，避免破版。
 * 资源已在 02 票接入；首页 / 列表屏在后续票消费。
 */

export const VEST_CATEGORY_ICON_BY_NAME: Record<string, string> = {
  'Payment Issue': require('../assets/vest/icons/payment-issue.svg'),
  'App Features': require('../assets/vest/icons/app-features.svg'),
  'Subscription Issue': require('../assets/vest/icons/subscription-issue.svg'),
  'Technical Issue': require('../assets/vest/icons/technical-issue.svg'),
  'Earn Rewards': require('../assets/vest/icons/earn-rewards.svg'),
  'Account Issue': require('../assets/vest/icons/account-issue.svg'),
  'Ads Issue': require('../assets/vest/icons/ads-issue.svg'),
  'Episode Issue': require('../assets/vest/icons/episode-issue.svg')
}

/** 兜底 icon：未知类别名使用 */
export const VEST_CATEGORY_ICON_FALLBACK: string = require('../assets/vest/icons/app-features.svg')

export function getVestCategoryIcon(categoryName?: string | null): string {
  if (!categoryName) return VEST_CATEGORY_ICON_FALLBACK
  return (
    VEST_CATEGORY_ICON_BY_NAME[categoryName] || VEST_CATEGORY_ICON_FALLBACK
  )
}
